import { render, staticRenderFns } from "./PersonnelDetails.vue?vue&type=template&id=5e38396e&"
import script from "./PersonnelDetails.vue?vue&type=script&lang=js&"
export * from "./PersonnelDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelDetails.vue?vue&type=style&index=0&id=5e38396e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports